import React from "react";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable/CustomTable";
import Text from "../../../components/Common/Text";
import CheckRender from "../../../components/Common/CheckRender";
import { MODAL_ANEXOS_MAX_WIDTH } from "../utils/ValidacionesHojaQXScreenConstants";
import useEmpresa from "../../../hooks/useEmpresa";

const ModalAnexosValidaciones = ({
  isOpen,
  onClose,
  anexosAMostrar,
  columnsAnexos,
  dataAnexos,
}) => {
  const empresa = useEmpresa();

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      testid="modal-anexos"
      maxWidth={MODAL_ANEXOS_MAX_WIDTH}
    >
      <Section flexDirection="column">
        <Text
          size="20px"
          weight="bold"
          color={empresa?.COLOR_PRINCIPAL}
          margin="0 0 20px 0"
        >
          Anexos
        </Text>
        <CheckRender allowed={anexosAMostrar.length > 0}>
          <CustomTable
            columns={columnsAnexos}
            dataSource={dataAnexos}
            pageSize={10}
            containerWidth="100%"
            width="100%"
            testid="anexos-table"
          />
        </CheckRender>
        <CheckRender allowed={anexosAMostrar.length === 0}>
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            No hay anexos disponibles para esta cobertura
          </div>
        </CheckRender>
      </Section>
    </CustomModal>
  );
};

export default ModalAnexosValidaciones;

